export class SubmitData {
  tellerNumber!: number;
  resolutionReason?: string;
  reasonId?: number;
  infoComment?: string;
  disputeAmount?: number;
  isReviewed?: boolean;
  lastModifiedTeller?: number;
}